import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import { getCollectVideo } from '../../../../../services/api';

/**
 * 定义 CollectTitle 组件
 */
class CollectTitle extends PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
        encodeId: PropTypes.string,
        isVideoShare: PropTypes.bool,
        wxLaunch: PropTypes.object,
        crowdid: PropTypes.string,
    };

    introDom = React.createRef();
    anthologyActiveDom = React.createRef();
    anthologyBoxDom = React.createRef();
    anthologyBoxPaddingLeftDom = React.createRef();

    state = {
        collectData: {},
        isUnfold: true,
    };

    async componentDidMount() {
        const { base62Id, encodeId, crowdid } = this.props;

        try {
            const collectData = await getCollectVideo(base62Id, crowdid);

            if (collectData) {
                await this.setState({
                    collectData,
                });
            }
        } catch (e) {
            console.log('请求视频合集接口失败');
        }
        this.introHandle();
        this.anthologyHandle();
    }

    introHandle = () => {
        const introLineHeight = window.getComputedStyle(this.introDom.current).lineHeight;
        const introHeight = window.getComputedStyle(this.introDom.current).height;

        if (parseInt(introHeight) > parseInt(introLineHeight) * 2) {
            this.setState({
                isUnfold: false,
            });
        }
    };
    anthologyHandle = () => {
        if (!this.anthologyActiveDom.current) return false;
        const anthologyBoxDom = this.anthologyBoxDom.current;
        const anthologyWidth = window.getComputedStyle(this.anthologyActiveDom.current).width;
        const anthologyPaddingRight = window.getComputedStyle(this.anthologyActiveDom.current).paddingRight;
        const anthologyBoxPaddingLeft = window.getComputedStyle(this.anthologyBoxPaddingLeftDom.current).paddingLeft;
        const anthologyScrollLeft = this.anthologyActiveDom.current.offsetLeft;
        const scrollWidth =
            parseInt(anthologyScrollLeft) -
            parseInt(anthologyWidth) -
            parseInt(anthologyBoxPaddingLeft) -
            parseInt(anthologyPaddingRight);

        anthologyBoxDom.scrollTo(scrollWidth, 0);
    };

    anthologyClickHandle = (index, id, isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { base62Id, isVideoShare, crowdid } = this.props;
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
              };

        if (isSendCount) {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'action',
                    type: 'openset',
                    other: {
                        to: `ucms_${id}`,
                        ref: `ucms_${base62Id}`,
                        rnum: index,
                        kind: 'videoseries',
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'action',
                    type: 'openset',
                    other: {
                        to: `ucms_${id}`,
                        ref: `ucms_${base62Id}`,
                        rnum: index,
                        kind: 'videoseries',
                        url: encodeURIComponent(location.href),
                        tag: 't9',
                    },
                },
            ]);
        }

        if (isCallApp) {
            callApp({
                docType: 'videoSeries',
                pid: id,
                crowdid,
                kind: 'share01',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    moreClickHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { base62Id, isVideoShare, crowdid } = this.props;
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
              };

        if (isSendCount) {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'action',
                    type: 'moreset',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'videoseries',
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        if (isJumpQQlink) {
            h5PageCount([
                {
                    datatype: isVideoShare ? 'vappsns_ex' : 'newsappsns',
                    behavior: 'action',
                    type: 'moreset',
                    other: {
                        ref: `ucms_${base62Id}`,
                        kind: 'videoseries',
                        url: encodeURIComponent(location.href),
                        tag: 't9',
                    },
                },
            ]);
        }

        if (isCallApp) {
            callApp({
                docType: 'videoSeries',
                pid: base62Id,
                crowdid,
                kind: 'share01',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    unflodMoreHandle = () => {
        this.setState({
            isUnfold: true,
        });
    };

    render() {
        const { collectData, isUnfold } = this.state;
        const { wxLaunch, isVideoShare, base62Id, crowdid } = this.props;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const pageSchemeLink = getSchemeLink({
            docType: 'videoSeries',
            pid: base62Id,
            crowdid,
            kind: 'share01',
        });

        return collectData.id ? (
            <section aria-label="视频播放信息" className={styles.collectBox}>
                <div className={styles.collectInfo}>
                    {collectData.title && <div className={styles.collectTitle}>{collectData.title}</div>}
                    <div className={styles.collectFaceBox}>
                        {collectData.headPic && (
                            <div className={styles.collectFacePic}>
                                <img className={styles.collectFace} src={collectData.headPic} />
                                {collectData.honorImg && (
                                    <img className={styles.collectFaceAddv} src={collectData.honorImg} />
                                )}
                            </div>
                        )}
                        {collectData.userName && <div className={styles.collectName}>{collectData.userName}</div>}
                    </div>
                    {collectData.introduction && (
                        <div
                            ref={this.introDom}
                            className={`${styles.collectInfoText} ${isUnfold ? styles.collectInfoAllText : ''}`}>
                            {collectData.introduction}
                            <span className={styles.collectUnfold} onClick={this.unflodMoreHandle}>
                                展开
                            </span>
                        </div>
                    )}
                </div>
                <div className={styles.collectList}>
                    <div className={styles.collectListMd}>
                        <div className={styles.collectListName}>选集</div>
                        {collectData.anthologyLength && (
                            <div className={styles.collectListNum} onClick={this.moreClickHandle}>
                                共{collectData.anthologyLength}个
                                {wxLaunchSwitch &&
                                    !isVideoShare && (
                                        <WxLaunchApp
                                            launchType={'app'}
                                            launchAppClick={this.moreClickHandle.bind(this, true, false, false)}
                                            schemeLink={pageSchemeLink}
                                            launchAppFail={this.moreClickHandle.bind(this, true, false, false)}
                                        />
                                    )}
                            </div>
                        )}
                    </div>
                    <div className={styles.collectListBox} ref={this.anthologyBoxPaddingLeftDom}>
                        {collectData.anthologyList &&
                            collectData.anthologyList.length > 0 && (
                                <div ref={this.anthologyBoxDom} className={styles.collectListScroll}>
                                    {collectData.anthologyList.map((item, index) => {
                                        const schemeLink = getSchemeLink({
                                            docType: 'videoSeries',
                                            pid: item.id,
                                            crowdid: item.crowdid,
                                            kind: 'share01',
                                        });

                                        return item.isAction ? (
                                            <div
                                                key={index}
                                                ref={this.anthologyActiveDom}
                                                onClick={this.anthologyClickHandle.bind(this, index, item.id)}
                                                className={`${styles.collectListItem} ${styles.collectListActive}`}>
                                                <div className={styles.collectListPicBox}>
                                                    {item.thumbnail && (
                                                        <img className={styles.collectListPic} src={item.thumbnail} />
                                                    )}
                                                    {item.isFeatured && <span className={styles.collectListGoodIcon} />}
                                                    {item.episode && (
                                                        <span className={styles.collectListDigital}>
                                                            {item.episode}
                                                        </span>
                                                    )}
                                                    <span className={styles.collectListShadow} />
                                                    <span className={styles.collectListCallIcon} />
                                                    {item.videoLength && (
                                                        <span className={styles.collectListTime}>
                                                            {item.videoLength}
                                                        </span>
                                                    )}
                                                    <span className={styles.collectListPaly} />
                                                </div>
                                                <div className={styles.collectListText}>{item.title}</div>
                                                {wxLaunchSwitch &&
                                                    !isVideoShare && (
                                                        <WxLaunchApp
                                                            launchType={'app'}
                                                            launchAppClick={this.anthologyClickHandle.bind(
                                                                this,
                                                                index,
                                                                item.id,
                                                                true,
                                                                false,
                                                                false,
                                                            )}
                                                            schemeLink={schemeLink}
                                                            launchAppFail={this.anthologyClickHandle.bind(
                                                                this,
                                                                index,
                                                                item.id,
                                                                true,
                                                                false,
                                                                false,
                                                            )}
                                                        />
                                                    )}
                                            </div>
                                        ) : (
                                            <div
                                                key={index}
                                                onClick={this.anthologyClickHandle.bind(this, index, item.id)}
                                                className={`${styles.collectListItem}`}>
                                                <div className={styles.collectListPicBox}>
                                                    {item.thumbnail && (
                                                        <img className={styles.collectListPic} src={item.thumbnail} />
                                                    )}
                                                    {item.isFeatured && <span className={styles.collectListGoodIcon} />}
                                                    {item.episode && (
                                                        <span className={styles.collectListDigital}>
                                                            {item.episode}
                                                        </span>
                                                    )}
                                                    <span className={styles.collectListShadow} />
                                                    <span className={styles.collectListCallIcon} />
                                                    {item.videoLength && (
                                                        <span className={styles.collectListTime}>
                                                            {item.videoLength}
                                                        </span>
                                                    )}
                                                    <span className={styles.collectListPaly} />
                                                </div>
                                                <div className={styles.collectListText}>{item.title}</div>
                                                {wxLaunchSwitch &&
                                                    !isVideoShare && (
                                                        <WxLaunchApp
                                                            launchType={'app'}
                                                            launchAppClick={this.anthologyClickHandle.bind(
                                                                this,
                                                                index,
                                                                item.id,
                                                                true,
                                                                false,
                                                                false,
                                                            )}
                                                            schemeLink={schemeLink}
                                                            launchAppFail={this.anthologyClickHandle.bind(
                                                                this,
                                                                index,
                                                                item.id,
                                                                true,
                                                                false,
                                                                false,
                                                            )}
                                                        />
                                                    )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                    </div>
                </div>
            </section>
        ) : (
            ''
        );
    }
}

export default errorBoundary(CollectTitle);
